import { render, staticRenderFns } from "./areaPolicy.vue?vue&type=template&id=4398d618&"
import script from "./areaPolicy.vue?vue&type=script&lang=js&"
export * from "./areaPolicy.vue?vue&type=script&lang=js&"
import style0 from "./areaPolicy.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports